export const Administration_Wing = [
    {
      title: "Chancellor",
      link: "/administration/chancellor",
    },
    {
      title: "Vice Chancellor",
      link: "/administration/vice-chancellor",
    },
    {
      title: "Registrar",
      link: "/administration/registrar",
    },
    {
      title: "Program Offered",
      link: "/academics/programs-offered",
    },
  
    {
      title: "Affliated Colleges",
      link: "/academics/affliated-colleges",
    },
  ];
  
  export const Central_Facilites = [
    {
      title: "Dr.YSR Central Library",
      link: "/",
    },
  
    {
      title: "Training & Placement",
      link: "/",
    },
  
    {
      title: "National Service Scheme (NSS)",
      link: "/",
    },
    {
      title: "Anti Ragging Committee",
      link: "/",
    },
  ];
  
  export const Online_Courses = [
    {
      title: "Swayam Central",
      link: "/",
    },
    {
      title: "UGC MOOCs: A Vertical of SWAYAM",
      link: "/",
    },
  
    {
      title: "Dr.YSR Central Library",
      link: "/",
    },
  ];
  
  export const Constituent_Colleges = [
    {
      title: "JNTU-GV College of Engineering, Vizianagaram",
      link: "https://jntugvcev.edu.in/",
    },
    {
      title:"JNTU-GV Tribal College of Engineering, Kurupam",
      link:"http://jntugvk.ucev.in/"
    }
  ];
  
  export const University_Hostels = [
    {
      title: "Gostani",
      link: "/",
    },
    {
      title: "Vegavathi",
      link: "/",
    },
    {
      title: "nagavalli",
      link: "/",
    },
    {
      title: "vamsadhara",
      link: "/",
    },
  ];
  
  export const JntuGv_Units = [
    {
      title: "DMC",
      link: "/",
    },
    {
      title: "IQAC",
      link: "/",
    },
    {
      title: "Sports",
      link: "/",
    },
    {
      title: "Library",
      link: "/",
    },
    {
      title: "Incubation Center",
      link: "/",
    },
  ];
  
  export const Grievance = [
    {
        title: "Student Grievance",
        link:"/grievance-form"
    },
    {
      title: "Recruitment Grievance",
      link:"mailto:recruitmentgrievances@jntugv.edu.in"
  },
  ]